export const NON_ZERO_WIDTH_WHITESPACE = '\u00a0';

const dayInMilliseconds = 1000 * 60 * 60 * 24;
const today = new Date();
export const taskInfoDate = new Date(today.getTime() - dayInMilliseconds);
